module.exports = __webpack_public_path__ + "img/app_purpose_02.667d0775.jpg";